import React, { useEffect, useState, useContext } from "react";
import "./ChatNav.css";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";

import {
  Avatar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Stack,
  Paper,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CallIcon from "@mui/icons-material/Call";
import VideocamIcon from "@mui/icons-material/Videocam";

import { ChatContext } from "../../../contexts/ChatContext";
import ChatServices from "../../../services/ChatServices";
import LetterAvatars from "../../Avatar";
import LetterAvatarSecond from "../../AvatarSecond";

import { withRouter } from "react-router-dom";
import { capitalize } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { showContactsArea } from "../../../redux/manageChatArea/chatAreaStatus.action";

import ConfirmationDialog from "../Dialog/ConfirmationDialog";
import { toast } from "react-toastify";

import SubscriptionRequired from "../../SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "../../SubscriptionAccess";

const ChatNav = (props) => {
  const {
    selectedChat,
    selectedGroupId,
    userId,
    selectedContactId,
    showFilePage,
    setShowFilePage,
    setSelectedInboxId,
    setDeleteGroupId,
    fetchUsersChat,
  } = useContext(ChatContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [Title, setTitle] = useState("");
  const [Content, setContent] = useState("");
  const [from, setFrom] = useState("");
  const [Status, setStatus] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const dispatch = useDispatch();
  const { showChats, showContacts } = useSelector((state) => state.manageChat);

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const clearSelectedChat = () => {
    setSelectedInboxId(null);
    setDeleteGroupId(null);
    dispatch(showContactsArea());
  };

  const [subReqOpen, setSubReqOpen] = useState(false);
  const [isFeatureInside, setIsFeatureInside] = useState(false);

  const handleopenFileSection = () =>{ 
    if(accessToShareFiles == false){
      setSubReqOpen(true)
      setIsFeatureInside(true)
      return
    }
    setShowFilePage(!showFilePage);
    }

  const accessToShareFiles = useCheckSubscriptionPlanAccess("shareFiles")

  // ====== Confirmation Dialog Handler ======
  const HandleDialog = (item) => {
    setFrom(item);

    let title = "";
    let content = "";

    switch (item) {
      case "Archive":
        setStatus(true);
        title = "Archive Chat Confirmation";
        content =
          "Are you sure you want to archive this chat? Once archived, the chat will be moved to the archive section.";
        break;
      case "UnArchive":
        setStatus(false);
        title = "Unarchive Chat Confirmation";
        content =
          "Are you sure you want to unarchive this chat? Once unarchived, the chat will return to the main section.";
        break;
      case "DeleteChat":
        title = "Delete Chat Confirmation";
        content = "Are you sure you want to delete this chat? This action cannot be undone.";
        break;
      case "RemoveContact":
        title = "Remove Contact Confirmation";
        content =
          "Are you sure you want to remove this contact? This will delete the chat history.";
        break;
      case "DeleteGroupChat":
        title = "Delete Group Chat Confirmation";
        content = "Are you sure you want to delete this group chat?";
        break;
      case "ExitGroup":
        title = "Exit Group Confirmation";
        content =
          "Are you sure you want to exit this group? You will be removed from the group.";
        break;
      case "ArchiveGroupChat":
        setStatus(true);
        title = "Archive Group Chat Confirmation";
        content =
          "Are you sure you want to archive this group chat? It will be moved to archive.";
        break;
      case "UnArchiveGroupChat":
        setStatus(false);
        title = "Unarchive Group Chat Confirmation";
        content =
          "Are you sure you want to unarchive this group chat? It will return to main chat.";
        break;
      default:
        break;
    }

    setTitle(title);
    setContent(content);
    handleClose();
    setOpenConfirmationDialog(true);
  };

  // ===== JSX UI (Teams Navigation) =====

  return (
    <>
    <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} isFeatureInside={isFeatureInside} setIsFeatureInside={setIsFeatureInside} path={"chat"}/>
    
    <Paper
      square
      elevation={0}
      sx={{
        width: "100%",
        borderRadius: 2,
        background: "linear-gradient(90deg, #202f9bff, #6e77dcff)",
        color: "#fff",
        p: 1.5,
      }}
    >
      {/* Confirmation dialog */}
      <ConfirmationDialog
        Title={Title}
        Content={Content}
        from={from}
        openConfirmationDialog={openConfirmationDialog}
        setOpenConfirmationDialog={setOpenConfirmationDialog}
        handleArchive={async () => {
          try {
            const response = await ChatServices.archiveChat(
              selectedChat?.userId,
              Status
            );
            if (response.status === 200) {
              await fetchUsersChat();
              toast.success(Status ? "Chat archived" : "Chat unarchived");
            }
            setOpenConfirmationDialog(false);
          } catch (err) {
            toast.error(err.message);
          }
        }}
        handleArchiveGroup={async () => {
          try {
            const response = await ChatServices.manageArchiveGroupChat(
              selectedGroupId,
              Status
            );
            if (response.status === 200) {
              await fetchUsersChat();
              toast.success(Status ? "Group chat archived" : "Group chat unarchived");
            }
            setOpenConfirmationDialog(false);
          } catch (err) {
            toast.error(err.message);
          }
        }}
        handleDeleteChat={async () => {
          try {
            let res;
            if (!selectedGroupId) {
              res = await ChatServices.deleteAllMessages(userId, selectedChat.userId);
            } else {
              res = await ChatServices.deleteAllMessagesinGroup(
                userId,
                selectedGroupId
              );
            }
            if (res.status === 200) {
              await fetchUsersChat();
              toast.success("Chat deleted");
            }
            setOpenConfirmationDialog(false);
          } catch (err) {
            toast.error(err.message);
          }
        }}
        handleDeleteContact={async () => {
          try {
            let res;
            if (!selectedGroupId) {
              res = await ChatServices.deleteContact(userId, selectedChat.userId);
            } else {
              res = await ChatServices.deleteGroupContact(userId, selectedGroupId);
            }
            if (res.status === 200) {
              await fetchUsersChat();
              toast.success("Contact removed");
              clearSelectedChat();
            }
            setOpenConfirmationDialog(false);
          } catch (err) {
            toast.error(err.message);
          }
        }}
      />

      <Grid2 container alignItems="center" justifyContent="space-between">
        {/* Left side */}
        <Grid2 display="flex" alignItems="center" gap={2}>
          <IconButton onClick={clearSelectedChat} sx={{ color: "#fff" }}>
            <ArrowBackIcon />
          </IconButton>

          {/* Avatar (group/user) */}
          {selectedGroupId ? (
            <LetterAvatarSecond name={selectedChat?.name} />
          ) : (
            <LetterAvatars
              name={selectedChat?.name}
              status={selectedChat?.status}
            />
          )}

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 , color: "#fff" }}>
              {capitalize(selectedChat?.name)}
            </Typography>

            {!selectedGroupId && (
              <Typography variant="caption" sx={{color: "#fff" }}>
                {selectedChat?.status}</Typography>
            )}
          </Box>
        </Grid2>

        {/* Right side */}
        <Grid2 display="flex" alignItems="center" gap={2}>
          <Typography
            variant="subtitle2"
            onClick={handleopenFileSection}
            sx={{ cursor: "pointer", fontWeight: 600 , color: "#fff" }}
          >
            {!showFilePage ? "Shared Files" : "Chats"}
          </Typography>

          <IconButton onClick={handleClick} sx={{ color: "#fff" }}>
            <MoreVertIcon />
          </IconButton>

          {/* Menu */}
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {!selectedGroupId ? (
              <>
                {selectedChat?.isArchive ? (
                  <MenuItem onClick={() => HandleDialog("UnArchive")}>
                    Remove From Archive
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => HandleDialog("Archive")}>
                    Archive Chat
                  </MenuItem>
                )}

                <MenuItem onClick={() => HandleDialog("DeleteChat")}>
                  Delete Chat
                </MenuItem>

                <MenuItem onClick={() => HandleDialog("RemoveContact")}>
                  Remove Contact
                </MenuItem>
              </>
            ) : (
              <>
                {selectedChat?.isArchive ? (
                  <MenuItem onClick={() => HandleDialog("UnArchiveGroupChat")}>
                    Remove From Archive
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => HandleDialog("ArchiveGroupChat")}>
                    Archive Group Chat
                  </MenuItem>
                )}

                <MenuItem onClick={() => HandleDialog("DeleteGroupChat")}>
                  Delete Group Chat
                </MenuItem>
                <MenuItem onClick={() => HandleDialog("ExitGroup")}>
                  Exit Group
                </MenuItem>
              </>
            )}
          </Menu>
        </Grid2>
      </Grid2>
    </Paper>
    </>
  );
};

export default withRouter(ChatNav);
